import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface BulkRetryConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  handleBulkRetry: () => void;
}

export const BulkRetryConfirmationDialog: React.FC<
  BulkRetryConfirmationDialogProps
> = ({ open, onOpenChange, selectedCount, handleBulkRetry }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Vorgänge erneut verarbeiten?</AlertDialogTitle>
          <AlertDialogDescription>
            {selectedCount === 1
              ? 'Möchten Sie wirklich einen Vorgang zur erneuten Verarbeitung senden? Der Vorgang wird mit den aktuellen Daten erneut eingespielt.'
              : `Möchten Sie wirklich ${selectedCount} Vorgänge zur erneuten Verarbeitung senden? Die Vorgänge werden mit den aktuellen Daten erneut eingespielt.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Abbrechen</AlertDialogCancel>
          <AlertDialogAction onClick={handleBulkRetry}>
            Erneut verarbeiten
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
